import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const PaymentInitiate = () => {
  const [iframeSrc, setIframeSrc] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.html) {
      // Create a blob URL from the HTML response
      const blob = new Blob([location.state.html], { type: "text/html" });
      const url = URL.createObjectURL(blob);

      setIframeSrc(url);

      // Cleanup the object URL after component unmounts
      return () => URL.revokeObjectURL(url);
    }
  }, [location.state?.html]);

  return (
    <div>
      {iframeSrc && (
        <iframe
          src={iframeSrc}
          style={{ width: "100%", height: "500px", border: "1px solid #ccc" }}
          title="API Response"
        />
      )}
    </div>
  );
};

export default PaymentInitiate;
